<template>
  <v-sheet class="mx-auto" max-width="2000">
    <v-card class="mx-auto" min-height="600" title="Graph output">
      <v-row no-gutters>
        <v-col>
          <GChart type="ColumnChart" min-height="600px"
                  :data="epiChatChartData"
                  :options="epiChatChartOptions"
                  v-if="epiChatChartData.length !== 0 && epiChatChartType === 'bar'"/>
          <GChart type="LineChart" min-height="600px"
                  :data="epiChatChartData"
                  :options="epiChatChartOptions"
                  v-if="epiChatChartData.length !== 0 && epiChatChartType === 'line'"/>
          <GChart type="ScatterChart" min-height="600px"
                  :data="epiChatChartData"
                  :options="epiChatChartOptions"
                  v-if="epiChatChartData.length !== 0 && epiChatChartType === 'scatter'"/>
          <v-chip variant="elevated" size="x-large" density="default" v-if="epiChatChartData.length === 0">
            When instructed to plot data, the output is visible here.
          </v-chip>
        </v-col>
      </v-row>
    </v-card>
    <v-card class="mx-auto" min-height="600" elevation="1"  title="Chat">
      <v-row no-gutters>
        <v-col>
          <ProgressBar mode="indeterminate" style="height: 4px" :hidden="!chatProgress"></ProgressBar>
        </v-col>
      </v-row>
      <v-row class="ml-4" no-gutters>
        <v-col>
          <Terminal
              welcomeMessage="Welcome to Epi-chat! Please start querying the lung cancer dataset."
              prompt="epichat$&nbsp;"
          />
        </v-col>
      </v-row>
    </v-card>
  </v-sheet>
</template>

<script>
import {defineComponent} from 'vue';
import {GChart} from 'vue-google-charts'
import Terminal from 'primevue/terminal';
import TerminalService from 'primevue/terminalservice'
import ProgressBar from 'primevue/progressbar';
import axios from "axios";

export default defineComponent({
  name: 'CancerEpiChat',
  props: {
    icd: String,
    visible: Boolean
  },
  components: {
    GChart,
    Terminal,
    ProgressBar
  },
  data: () => ({
    chatProgress: false,
    epiChatChartType: 'bar',
    epiChatChartData: [],
    epiChatChartOptions: {
      backgroundColor: {
        fill: '#364c5b'
      },
      height: 600,
      colors: ['#a6cee3', '#b2df8a', '#fb9a99', '#fdbf6f', '#cab2d6', '#ffff99', '#1f78b4', '#33a02c'],
      legend: {
        position: 'bottom',
        alignment: 'end',
        textStyle: {color: '#c0c0c0', fontSize: 16},
        scrollArrows: {
          activeColor: '#f0f0f0',
          inactiveColor: 'c0c0c0'
        },
        pagingTextStyle: {
          color: '#f0f0f0'
        }
      },
      hAxis: {
        title: '',
        titleTextStyle: {
          color: '#f0f0f0',
          italic: false
        },
        gridlines: {
          count: 0
        },
        minorGridlines: {
          count: 0
        },
        textStyle: {
          color: '#ffffff'
        }
      },
      vAxis: {
        title: '',
        titleTextStyle: {
          color: '#f0f0f0',
          italic: false
        },
        gridlines: {
          count: 0
        },
        minorGridlines: {
          count: 0
        },
        textStyle: {
          color: '#ffffff'
        }
      }
    }
  }),
  methods: {
    async callChat(query) {
      console.log('Query: ' + query)
      return axios.get('epi-chat',
          {
            headers: { Authorization: `Bearer ${this.$store.getters.stateUser.keycloak_token}` },
            params: {
              icd: this.icd,
              q: query
            }
          });
    }
  },
  mounted() {
    TerminalService.on('command', (command) => {
      if (command.trim() === 'quit') {
        console.log('Quit command received')
        TerminalService.off('response', 'Bye!')
      } else {
        this.chatProgress = true
        this.callChat(command.trim())
            .then(response => {
              if (response.data.data === undefined) {
                TerminalService.emit('response', response.data)
              } else {
                try {
                  this.epiChatChartType = response.data.type
                  this.epiChatChartData = response.data.data
                  this.epiChatChartOptions.hAxis.title = response.data.horizontalLabel
                  this.epiChatChartOptions.vAxis.title = response.data.verticalLabel
                } catch (e) {
                  this.epiChatChartData = []
                  console.log(e)
                  TerminalService.emit('response', 'Failed to draw chart. Please try again.')
                } finally {
                  this.chatProgress = false
                }
              }
        }).catch(error => {
          TerminalService.emit('response', 'Failed to evaluate command')
          this.chatProgress = false
          console.log(error)
        })
      }
    });

    TerminalService.on('response', (response) => {
      console.log('Response: ' + response)
    })
  }
});
</script>

<style scoped>
.p-terminal {
  font-family: Roboto,sans-serif;
  font-size: 1.5em;
  background-color: #364c5b;
  color: #ffffff;
  border: 0;
}

@layer primevue {
  .p-progressbar {
    background-color: #364c5b;
  }
}
</style>
